module.exports = __webpack_public_path__ + "img/star-fill.1b0b1439.svg";